// extracted by mini-css-extract-plugin
module.exports = {"ExperienceIcon":"ExperienceIcon_ExperienceIcon__1W1kV"};